export const defaultButtonText = "Next";
export const defaultHeaderTitleText = "";